import React from 'react'
import { Typography, Row, Col } from 'antd'
import BrokerQuickLinks from 'components/broker/BrokerQuickLinks'
import CurrencyFOBrokerage from 'components/broker/CurrencyFOBrokerage'
import CurrencyTrading from 'components/broker/CurrencyTrading'
import ArticleList from 'components/shared/ArticleList'
import PropTypes from 'prop-types'

const header = ({ broker }) => {
  return `${
    broker.name
  }: Currency Trading: Brokerage, Charges, Reviews: ${new Date().getFullYear()}`
}

export default function CurrencyTradingMain({ broker, articles }) {
  const { Title } = Typography

  return (
    <Row className="page-wrapper page" gutter={[16, 16]}>
      <Title className="title-wrapper" style={{ width: '100%' }}>
        {header({ broker })}
      </Title>
      <Col xs={24} md={16}>
        <CurrencyTrading broker={broker} />
        <CurrencyFOBrokerage broker={broker} />
        <ArticleList articles={articles} />
      </Col>
      <Col xs={24} md={8}>
        <BrokerQuickLinks
          broker={broker}
          RenderReview
          currentPage="currencyTrading"
        />
      </Col>
    </Row>
  )
}

CurrencyTradingMain.propTypes = {
  broker: PropTypes.shape({
    details: PropTypes.string.isRequired,
  }).isRequired,
}
